var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 117,
    viewBox: "0 0 117 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 53.125,
    fill: "#06CEA8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.8545 45.6424L51.3496 69.0228L40.158 57.8312C39.7136 57.3711 39.182 57.004 38.5942 56.7516C38.0064 56.4991 37.3743 56.3662 36.7346 56.3606C36.0949 56.355 35.4605 56.4769 34.8684 56.7192C34.2763 56.9614 33.7384 57.3192 33.2861 57.7715C32.8337 58.2238 32.476 58.7618 32.2338 59.3538C31.9915 59.9459 31.8696 60.5803 31.8752 61.22C31.8807 61.8597 32.0136 62.4919 32.2661 63.0796C32.5186 63.6674 32.8857 64.199 33.3458 64.6435L47.7989 79.0966C48.6769 79.9747 49.8599 80.4799 51.1013 80.5068C52.3427 80.5337 53.5466 80.0803 54.4618 79.2411L83.3681 52.7437C84.3097 51.88 84.8697 50.6775 84.9249 49.4009C84.98 48.1242 84.5257 46.878 83.6619 45.9363C82.7982 44.9946 81.5957 44.4346 80.3191 44.3795C79.0424 44.3244 77.7962 44.7787 76.8545 45.6424Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigCheckMark);
export default __webpack_public_path__ + "static/media/big-check-mark.0945c0fff9021c79c3a53e5ca924b519.svg";
export { ForwardRef as ReactComponent };